export const RESPONSIVE_EMAILS_DELETE_TEXT = {
    id: 'oe.website.responsiveEmails.delete',
    defaultMessage: 'Delete Email',
    description: 'Button text'
};

export const RESPONSIVE_EMAILS_ENABLED_TEXT = {
    message: 'The Responsive Email is {suffix}',
    id: 'oe.website.responsiveEmailIsEnabled',
    description: 'Label text',
};

export const DISABLED_RESPONSIVE_EMAIL_INFO_TEXT = {
    message: `Even when a responsive email is disabled, you can still send it manually. On the Attendees tab, Edit 
        the Attendee, or bulk-select Attendees and choose the 'Edit # Attendees’ button that appears above the list.`,
    id: 'oe.website.disabledResponsiveEmailInfo',
    description: 'Label text',
};

export const STARTING_TEMPLATE_TEXT = {
    id: 'oe.website.responsiveEmails.startingTemplate',
    defaultMessage: 'Starting Template',
    description: 'Title text'
};

export const TRIAGE_QUESTION_ANSWER_TEXT = {
    id: 'oe.website.responsiveEmails.triageQuestionAnswer',
    defaultMessage: 'Triage Question Answer',
    description: 'Title text'
};

export const REGISTRATION_EMAIL_IS_BEING_SAVED_TEXT = {
    id: 'oe.website.registrationEmailIsBeingSaved',
    description: 'Placeholder about saving account',
    defaultMessage: 'Registration Email is being saved, please wait...'
};

export const REGISTRATION_CALENDAR_INVITATION_TEXT = {
    message: 'Send upon registration is {suffix}',
    id: 'oe.website.registrationCalendarInvitationText',
    description: 'Label text',
};

export const REGISTRATION_CALENDAR_INVITATION_DISABLED_TEXT = {
    id: 'oe.website.registrationEmailIsDisabled',
    description: 'Label text',
    defaultMessage: '\nSend upon registration is disabled'
};

export const RESPONSIVE_EMAILS_DISABLED = {
    id: `oe.passport.responsiveEmails.disabled`,
    defaultMessage: '(Disabled)',
    description: 'Button text'
};

export const REGISTRATION_CALENDAR_INVITATION_TITLE = 'Registration Calendar Invitation';

export const REGISTRATION_CALENDAR_INVITATION = 'Registration Calendar Invitation';
export const MEETINGN_CALENDAR_INVITATION = 'Meeting Calendar Invitation';
export const BOOKABLE_MEETING_CALENDAR_INVITATION = 'Bookable Meeting Calendar Invitation';
export const PRESENTER_BOOKABLE_MEETING_CALENDAR_INVITATION = 'Presenter Bookable Meeting Calendar Invitation';

export const MEETING_CALENDAR_INVITATION_TITLE = 'Meeting Calendar Invitation';
export const BOOKABLE_MEETING_CALENDAR_INVITATION_TITLE = 'Bookable Meeting Calendar Invitation';
export const PRESENTER_BOOKABLE_MEETING_CALENDAR_INVITATION_TITLE = 'Presenter Bookable Meeting Calendar Invitation';